export const globals = {
  $config: {
    serverUrl: "https://www.zhengkedianji.cn/"
  }
}